import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=3771c296&scoped=true"
import script from "./Inventario.vue?vue&type=script&lang=js"
export * from "./Inventario.vue?vue&type=script&lang=js"
import style1 from "./Inventario.vue?vue&type=style&index=1&id=3771c296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3771c296",
  null
  
)

export default component.exports